/*
This file was created by the script build.py 
*/

import {getAllFiltered} from "./filter";
import {searchObjectAcceleratorParameters} from "./searchObjects"



export function fillSearchObjectAcceleratorParameters(){
    searchObjectAcceleratorParameters.categories = [];
    searchObjectAcceleratorParameters.keywords = [];

    const checkbox = document.getElementById("categoryAcceleratorParameters");
    if(checkbox.checked || checkbox.indeterminate){
        searchObjectAcceleratorParameters.categories.push(checkbox.value);
    }

    const anyButton = document.getElementById("buttonAcceleratorParametersAny");
    if(anyButton.classList.contains("chosen")){
        searchObjectAcceleratorParameters.any = true;
    }

    const allButton = document.getElementById("buttonAcceleratorParametersAll");
    if(allButton.classList.contains("chosen")){
        searchObjectAcceleratorParameters.any = false;
    }
    
    const button900GeV = document.getElementById("buttonAcceleratorParameters900GeV");
    if(button900GeV.classList.contains('selected')){
        searchObjectAcceleratorParameters.keywords.push(button900GeV.value)
    }
    
    const button7TeV = document.getElementById("buttonAcceleratorParameters7TeV");
    if(button7TeV.classList.contains('selected')){
        searchObjectAcceleratorParameters.keywords.push(button7TeV.value)
    }
    
    const button8TeV = document.getElementById("buttonAcceleratorParameters8TeV");
    if(button8TeV.classList.contains('selected')){
        searchObjectAcceleratorParameters.keywords.push(button8TeV.value)
    }
    
    const button13TeV = document.getElementById("buttonAcceleratorParameters13TeV");
    if(button13TeV.classList.contains('selected')){
        searchObjectAcceleratorParameters.keywords.push(button13TeV.value)
    }
    
    const button136TeV = document.getElementById("buttonAcceleratorParameters136TeV");
    if(button136TeV.classList.contains('selected')){
        searchObjectAcceleratorParameters.keywords.push(button136TeV.value)
    }
    
    const button14TeV = document.getElementById("buttonAcceleratorParameters14TeV");
    if(button14TeV.classList.contains('selected')){
        searchObjectAcceleratorParameters.keywords.push(button14TeV.value)
    }
    
    const button276TeV = document.getElementById("buttonAcceleratorParameters276TeV");
    if(button276TeV.classList.contains('selected')){
        searchObjectAcceleratorParameters.keywords.push(button276TeV.value)
    }
    
    const button544TeV = document.getElementById("buttonAcceleratorParameters544TeV");
    if(button544TeV.classList.contains('selected')){
        searchObjectAcceleratorParameters.keywords.push(button544TeV.value)
    }
    
    const button55TeV = document.getElementById("buttonAcceleratorParameters55TeV");
    if(button55TeV.classList.contains('selected')){
        searchObjectAcceleratorParameters.keywords.push(button55TeV.value)
    }
    
    const button502TeV = document.getElementById("buttonAcceleratorParameters502TeV");
    if(button502TeV.classList.contains('selected')){
        searchObjectAcceleratorParameters.keywords.push(button502TeV.value)
    }
    
    const button816TeV = document.getElementById("buttonAcceleratorParameters816TeV");
    if(button816TeV.classList.contains('selected')){
        searchObjectAcceleratorParameters.keywords.push(button816TeV.value)
    }
    
    getAllFiltered()

}